function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "22",
  viewBox: "0 0 22 22",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.333 7.292a3.61 3.61 0 003.613-3.625A3.61 3.61 0 0016.333.042a3.62 3.62 0 00-3.625 3.625 3.62 3.62 0 003.625 3.625zm-9.666 0a3.61 3.61 0 003.613-3.625A3.61 3.61 0 006.667.042a3.62 3.62 0 00-3.625 3.625 3.62 3.62 0 003.625 3.625zm0 2.416c-2.816 0-8.459 1.414-8.459 4.23v3.02h16.917v-3.02c0-2.816-5.643-4.23-8.458-4.23zm9.666 0c-.35 0-.749.024-1.172.06 1.402 1.016 2.38 2.381 2.38 4.17v3.02h7.25v-3.02c0-2.816-5.642-4.23-8.458-4.23z",
  fill: "#888",
  fillRule: "nonzero"
})));